import { map } from "d3";

export const buildBoxes = (users, orgDashboardStore) => {
  const boxes = [];
  let weight = 0;
  let buffer = [];

  users
    .filter((x) => x.pinned)
    .forEach((x) => {
      if (weight >= 8) {
        boxes.push(buffer);
        buffer = [];
        weight = 0;
      }
      buffer.push(x);
      weight += 8;
    });

  [
    ["red", 8],
    ["yellow", 2],
    ["green", 2],
    ["inactive", 0.4],
  ].forEach((row) => {
    const color = row[0];
    const colorWeight = row[1];
    users
      .filter((x) => x.color === color && !x.pinned)
      .forEach((x) => {
        if (weight >= 8) {
          boxes.push(buffer);
          buffer = [];
          weight = 0;
        }
        if (x.color === "inactive") {
          const heartRate = orgDashboardStore.heartRate[x.userCode];
          if (heartRate) {
            buffer.push(x);
            weight += x.expanded ? 8 : colorWeight;
          }
        } else {
          buffer.push(x);
          weight += x.expanded ? 8 : colorWeight;
        }
      });
  });
  if (buffer.length > 0) {
    boxes.push(buffer);
    buffer = [];
    weight = 0;
  }
  [["inactive", 0.4]].forEach((row) => {
    const color = row[0];
    const colorWeight = row[1];
    users
      .filter((x) => x.color === color && !x.pinned)
      .forEach((x) => {
        if (weight >= 8) {
          boxes.push(buffer);
          buffer = [];
          weight = 0;
        }

        const heartRate = orgDashboardStore.heartRate[x.userCode];
        if (!heartRate) {
          buffer.push(x);
          weight += x.expanded ? 8 : colorWeight;
        }
      });
  });
  if (buffer.length > 0) {
    boxes.push(buffer);
    buffer = [];
    weight = 0;
  }
  return boxes;
};

export function initials(name) {
  if (name.indexOf(" ") > 0) {
    const arr = name.split(" ");
    return `${arr[0][0].toUpperCase()}${arr[1][0].toUpperCase()}`;
  } else {
    return name.substr(0, 2).toUpperCase();
  }
}

export const timeSince = (date) => {
  var seconds = Math.max(0, Math.floor((new Date() - date) / 1000));
  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes";
  }
  return Math.floor(seconds) + " seconds";
};
